import { Component } from '@angular/core';

@Component({
  selector: 'tun-menu-settings-icon-v5',
  templateUrl: './menu-settings-icon-v5.component.html',
  styleUrls: ['./menu-settings-icon-v5.component.scss']
})
export class MenuSettingsIconV5Component {

}
